import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARFISH_HOMEPAGE_V2 = createFcmDetails('starfish_homepage_v2', {
	owner: 'starfish',
	context: 'Starfish Homepage V2',
	description:
		'Homepage V2 enabled boolean for homepage relaunch. This FCM takes precedence over the starfish_homepage_v2_content FCM.',
	import: false,
	template: {
		isEnabled: true,
		experimentName: 'starfish_homepage_v2',
	},
	mergeLogic: 'Requires both country and locale to be enabled and have the same experiment name.',
});
